module.exports = "<td><%= model.get('entry') %></td>"


//////////////////
// WEBPACK FOOTER
// ./src/components/interface/templates/row_view.template
// module id = 533
// module chunks = 51